import { post } from 'app/shared/utils/fetchr';
import { ALERT_QUERY_KEYS } from 'app/modules/alerts/queries/keys';
import { AlertHitsResponse } from 'app/modules/alerts/types/responses';
import { PaginationPayload } from 'app/shared/pagination/models';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectHasReadAlertsPermission } from 'app/modules/session/selectors';

const fetchAlertHitsInfinite = (
  alertId: number,
  paginationPayload: PaginationPayload,
): Promise<AlertHitsResponse> => {
  const path = `/alerts/${alertId}/hits`;
  return post(path, paginationPayload);
};

export const useFetchAlertHitsInfinite = (
  alertId: number | null,
  limit: number,
) => {
  const hasReadAlertsPermission = useSelector(selectHasReadAlertsPermission);

  const query = useInfiniteQuery({
    queryKey: ALERT_QUERY_KEYS.getAlertHitsInfinite(alertId!, limit),
    queryFn: ({ pageParam: offset }) =>
      fetchAlertHitsInfinite(alertId!, { offset, limit }),
    enabled: !!alertId && hasReadAlertsPermission,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      return lastPageParam + 1;
    },
  });

  return {
    query,
    allAlertHits: query.data?.pages.flatMap((page) => page.hits) ?? [],
    totalCount: query.data?.pages[0].count ?? 0,
  };
};
